<script>
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';
import RbxExtendedTextarea from '../../../shared/reybex/extendedTextarea/RbxExtendedTextarea';
import RbxDatePicker from '../../../shared/reybex/RbxDatePicker';

export default {
  name: 'MasterDataForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
    RbxExtendedTextarea,
    RbxDatePicker,
  },
  props: {
    procedureDirectory: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    onUnlimitedProcessing() {
      if (this.procedureDirectory.isProcessingUnlimited) {
        this.procedureDirectory.dataProcessingEnd = null;
      }
    },
    onPrivacyOfficerResponsible() {
      if (this.procedureDirectory.isPrivacyOfficerResponsible) {
        this.procedureDirectory.privacyOfficer = null;
      }
    },
    onStartDateInput(newDate) {
      this.procedureDirectory.dataProcessingStart = newDate;
    },
    onEndDateInput(newDate) {
      this.procedureDirectory.dataProcessingEnd = newDate;
    },
    cleanResponsibleAffiliate() {
      this.procedureDirectory.responsibleAffiliate = null;
    },
  },
};
</script>

<template>
  <v-form>
    <v-container fluid grid-list-lg pt-2 pa-0>
      <v-layout row wrap>

        <v-flex xs6 md4 py-0>
          <v-text-field
            v-model="procedureDirectory.name"
            label="Bezeichnung"
            height="22"
            class="caption"
          />
        </v-flex>

        <v-flex xs6 md4 py-0>
          <rbx-remote-combobox
            v-model="procedureDirectory.responsibleUser"
            label="Bearbeiter"
            :selected="procedureDirectory.responsibleUser"
            domain="User"
          />
        </v-flex>

        <v-flex xs6 md2 py-0>
          <rbx-remote-combobox
            v-model="procedureDirectory.responsibleAffiliate"
            label="Verantwortlicher"
            :selected="procedureDirectory.responsibleAffiliate"
            :disabled="procedureDirectory.isClientRespAffiliate"
            domain="Affiliate"
          />
        </v-flex>

        <v-flex xs6 md2 py-0>
          <v-checkbox
            v-model="procedureDirectory.isClientRespAffiliate"
            label="Mandant selbst verantwortlich"
            class="caption"
            @click.native="cleanResponsibleAffiliate"
            hide-details
          />
        </v-flex>

        <v-flex xs6 md4>
          <v-text-field
            v-model="procedureDirectory.privacyOfficer"
            label="Datenschutzbeauftragter"
            height="22"
            class="caption"
            :disabled="procedureDirectory.isPrivacyOfficerResponsible"
          />
        </v-flex>

        <v-flex xs6 md4>
          <rbx-remote-combobox
            v-model="procedureDirectory.examState"
            label="Status"
            :selected="procedureDirectory.examState"
            domain="ExamState"
          />
        </v-flex>

        <v-flex xs6 md4>
          <rbx-remote-combobox
            v-model="procedureDirectory.organizationalUnit"
            label="Organisationseinheit"
            :selected="procedureDirectory.organizationalUnit"
            domain="OrganizationalUnit"
          />
        </v-flex>

        <v-flex xs6 md4 py-0>
          <v-checkbox
            v-model="procedureDirectory.isPrivacyOfficerResponsible"
            label="Unternehmens-Datenschutzbeauftragter ist zuständig"
            class="caption"
            hide-details
            @click.native="onPrivacyOfficerResponsible"
          />
        </v-flex>

        <v-flex xs3 md2 py-0>
          <rbx-date-picker
            :value="procedureDirectory.dataProcessingStart"
            label="Beginn der Datenverarbeitung"
            @input="onStartDateInput"
          />
        </v-flex>

        <v-flex xs3 md2 py-0>
          <rbx-date-picker
            :value="procedureDirectory.dataProcessingEnd"
            label="Ende der Datenverarbeitung"
            @input="onEndDateInput"
          />
        </v-flex>

        <v-flex xs12 md3 py-0>
          <v-checkbox
            v-model="procedureDirectory.isProcessingUnlimited"
            label="Unbefristete Datenverarbeitung"
            class="caption"
            hide-details
            @click.native="onUnlimitedProcessing"
          />
        </v-flex>

        <v-flex xs12 md12 py-0>
          <v-textarea
            v-model="procedureDirectory.notes"
            label="Bemerkungen zum Verfahren"
            class="caption"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>
